export default __webpack_public_path__ + "static/media/Logo.250acd3c.svg";